import {Injectable} from '@angular/core';
import {AuthTokens} from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {

	private KEY = 'auth_tokens';

	save(tokens: AuthTokens) {
		sessionStorage.setItem(this.KEY, JSON.stringify(tokens));
	}

	get(): AuthTokens | null {
		const raw = sessionStorage.getItem(this.KEY);
		return raw ? JSON.parse(raw) : null;
	}

	clear() {
		sessionStorage.removeItem(this.KEY);
	}
}
